/**
 * useToast Hook
 * Hook for showing toast notifications
 */

import { useToastStore } from '../stores/toast.store';
import type { ToastType } from '../stores/toast.store';

export const useToast = () => {
  const { addToast } = useToastStore();

  return {
    toast: (message: string, type: ToastType = 'info', duration?: number) => {
      addToast(message, type, duration);
    },
    success: (message: string, duration?: number) => {
      addToast(message, 'success', duration);
    },
    error: (message: string, duration?: number) => {
      addToast(message, 'error', duration);
    },
    info: (message: string, duration?: number) => {
      addToast(message, 'info', duration);
    },
    warning: (message: string, duration?: number) => {
      addToast(message, 'warning', duration);
    },
  };
};
